import { useTranslation } from 'react-i18next';

import { FieldComponent, Toggle } from 'libs/form';
import { Help } from 'libs/ui';
import { ZoneInputBox } from '../styled';
import { Input, Inputs, Interface, Wrapper, Block, Title, ZoneLabel, InputWithHelp } from './hourly-day-night-tariffication.styled';

export const HourlyDayNightTariffication = (props) => {
  const { color, display, disabled } = props;
  const withFreeperiod = true;
  const withBoundaries = true;

  const { t } = useTranslation();

  return (
    <Interface color={color} display={display ? 'block' : 'none'}>
      <Wrapper>
        <Block>
          <Title>{t('form.Дневной период')}</Title>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Стоимость часа')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_hour_cost" title={t('form.Стоимость часа')} type="text" naturalNumber withZero maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Начало периода')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_start_time" title={t('form.Начало периода')} type="time" maxValueLength={8} />
              </ZoneInputBox>
            </Input>
          </Inputs>
        </Block>
        <Block>
          <Title>{t('form.Ночной период')}</Title>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Стоимость часа')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="night_hour_cost" title={t('form.Стоимость часа')} type="text" naturalNumber withZero maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Начало периода')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="night_start_time" title={t('form.Начало периода')} type="time" maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Максимальная стоимость за период')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="night_amount_limit" title={t('form.Максимальная стоимость за период')} type="text" naturalNumber withZero maxValueLength={8} />
              </ZoneInputBox>
            </Input>
          </Inputs>
        </Block>
        <Block>
          {withBoundaries && (
            <InputWithHelp>
              <Toggle className="black" label={t('form.Тарифицировать на границе дня и ночи')} name="use_boundaries" type="toggle" disabled={disabled} />
              <Help
                className="white"
                info="При начале дня (ночи) будет сразу начислена плата за час по дневному (ночному) тарифу. Например: начало дня 6:00, въезд в 5:30, выезд в 6:15, стоимость ночью 50 рублей в час, днём 100. При включении функции стоимость будет 50 за первые полчаса до наступления дня + 100 за дневной период. При отключенной функции только 50 за час при въезде в ночное время."
              />
            </InputWithHelp>
          )}
          {withFreeperiod && (
            <>
              <InputWithHelp>
                <Toggle className="black" label={t('form.Тарификация бесплатного времени')} name="use_freeperiod" type="toggle" disabled={disabled} />
                <Help
                  className="white"
                  info="При превышении бесплатного времени его необходимо будет оплатить. Например: бесплатное время 2 часа, стоимость в час 100 рублей. Въезд в 5:30, выезд в 8:15. При включении функции стоимость будет 300 за три часа. При отключенной функции только 100 за час сверх бесплатных двух часов."
                />
              </InputWithHelp>
              <Input>
                <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
                <ZoneInputBox wide>
                  <FieldComponent type="text" name="free_interval" title={t('form.Бесплатное время')} naturalNumber withZero maxValueLength={5} disabled={disabled} mask={{ suffix: t('form. мин') }} />
                </ZoneInputBox>
              </Input>
            </>
          )}
        </Block>
      </Wrapper>
    </Interface>
  );
};
